var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useCallback, useMemo } from 'react';
import { SpaceScheduleConfiguration } from '../../../generated/graphql';
/**
 * Hook for space booking logic including bookability checks and sorting.
 *
 * Rules for bookability:
 * - If the space is on-demand, it can be booked
 * - If the space is request-only and there are no spaces already added, it can be booked
 * - If the space is request-only and there are spaces already added, it cannot be booked
 * - If the space is already added to the event, it cannot be booked
 */
export var useSpaceBookingLogic = function (_a) {
    var spaces = _a.spaces, availabilityStateById = _a.availabilityStateById, spacesAdded = _a.spacesAdded, spaceIdsToHide = _a.spaceIdsToHide;
    var hideSet = useMemo(function () { return new Set(__spreadArray(__spreadArray([], __read((spacesAdded !== null && spacesAdded !== void 0 ? spacesAdded : [])), false), __read((spaceIdsToHide !== null && spaceIdsToHide !== void 0 ? spaceIdsToHide : [])), false)); }, [spacesAdded, spaceIdsToHide]);
    var isSpaceBookable = useCallback(function (space) {
        var spaceAvailabilityState = availabilityStateById[space.id];
        return ((spaceAvailabilityState === null || spaceAvailabilityState === void 0 ? void 0 : spaceAvailabilityState.available) &&
            space.scheduleConfiguration !== SpaceScheduleConfiguration.OnDemand &&
            !(!!(spacesAdded === null || spacesAdded === void 0 ? void 0 : spacesAdded.length) &&
                space.scheduleConfiguration === SpaceScheduleConfiguration.RequestOnly));
    }, [availabilityStateById, spacesAdded]);
    var sortedSpaces = useMemo(function () {
        var e_1, _a;
        if (!spaces)
            return undefined;
        // Partition: bookable spaces in one array, unbookable in another - O(n)
        var bookable = [];
        var unbookable = [];
        try {
            for (var spaces_1 = __values(spaces), spaces_1_1 = spaces_1.next(); !spaces_1_1.done; spaces_1_1 = spaces_1.next()) {
                var space = spaces_1_1.value;
                if (hideSet.has(space.id))
                    continue;
                if (isSpaceBookable(space)) {
                    bookable.push(space);
                }
                else {
                    unbookable.push(space);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (spaces_1_1 && !spaces_1_1.done && (_a = spaces_1.return)) _a.call(spaces_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Concatenate: bookable first, unbookable second - O(1)
        return __spreadArray(__spreadArray([], __read(bookable), false), __read(unbookable), false);
    }, [spaces, hideSet, isSpaceBookable]);
    return { isSpaceBookable: isSpaceBookable, sortedSpaces: sortedSpaces };
};
